<template>

    <div class="form-group">
        <label
            :for="'field-' + field.uuid"
            class="control-label"
            v-text="field.label"
        ></label>

        <input
            type="text"
            :class="{'form-control':true,'is-invalid form-control-danger':showError}"
            :id="'field-' + field.uuid"
            @input="$emit('input', $event.target.value)"
            :value="value"
        />

        <div
            class="form-error"
            v-if="showError"
            v-text="field.errormsg"
        />
    </div>

</template>

<script>

export default {

    name:'ContactformTypesInputtype',

    props: {
        field: {
            type:Object,
            required:true,
        },

        value: {
            required:true,
        },

        showError: {
            required:true,
            type:Boolean,
        },
    },
}

</script>
